export const FORMATOS = {
  presencial: { label: 'Presencial', field: 'Endereço', placeholder: 'Rua, número, bairro, cidade' },
  online: { label: 'Online', field: 'Link da reunião', placeholder: 'https://meet.google.com/...' },
  telefone: { label: 'Por telefone', field: 'Telefone', placeholder: '(11) 99999-9999' },
};

export const STATUS = {
  AGUARDANDO: { label: 'Aguardando confirmação', cls: 'bg-amber-100 text-amber-800' },
  CONFIRMADA: { label: 'Confirmada', cls: 'bg-emerald-100 text-emerald-800' },
  NOVO_HORARIO: { label: 'Candidato pediu outro horário', cls: 'bg-orange-100 text-orange-800' },
  CANCELADA: { label: 'Cancelada', cls: 'bg-slate-200 text-slate-600' },
  REALIZADA: { label: 'Realizada', cls: 'bg-cyan-100 text-cyan-800' },
};

export const ACTIVE_STATUS = ['AGUARDANDO', 'CONFIRMADA', 'NOVO_HORARIO'];

export const fmtDateTime = (iso) => new Date(iso).toLocaleString('pt-BR', {
  weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
});

export const fmtDay = (iso) => {
  const s = new Date(iso).toLocaleDateString('pt-BR', { weekday: 'long', day: '2-digit', month: 'long' });
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const NIVEL_LABELS = {
  entrega: 'Entrega', comportamento: 'Comportamento', cognitivo: 'Cognitivo',
  aspiracao: 'Aspiração', experiencia: 'Experiência', lideranca: 'Liderança',
};

export const isPast = (iso) => new Date(iso) <= new Date();

export const fmtTime = (iso) => new Date(iso).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

export const toLocalInput = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const placeHref = (formato, local) => {
  if (formato === 'online') return local;
  if (formato === 'telefone') return `tel:${(local || '').replace(/[^\d+]/g, '')}`;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(local || '')}`;
};
